import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './progress-bar.module.scss';

@classic
@classNames('progress-wrap', styles.component)
export default class SharedProgressBar extends Component {}
